<template>
  <div class="add-jobs-work-one-report">
    <div class="sticky-desktop-header">
      <div class="add-jobs-work one-report-search" style="margin-bottom: 32px">
        <div class="search-jobs-work">
          <div :class="['arrow-main' , {hide: hideAll}]" @click="hideAllHandler">
            <i :class="'fas fa-chevron-right'"></i>
          </div>
          <h3 class="desktop-show-create" style="margin-right: 12px; color: #000; font-size: 20px">Работы</h3>
          <el-input placeholder="Поиск ..." v-model="search" class="input-search">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>

          <div class="icons-auto desktop-show-create">
            <img src="@/assets/plan.png" @click="calcAllPlan">
            <img src="@/assets/fact.png" @click="calcAllFact">
          </div>
        </div>
      </div>
    </div>

    <div v-for="(object, index) in format(objects)" :key="object.id + index"
         v-show="(object.name || '').toLowerCase().includes(search.toLowerCase())">
      <div class="main-object-block">
        <div class="object-container" v-if="object.name">
          <div class="object-name">
            <div style="display:flex; align-items: center">
              <div @click="hideLines(index)" class="arrow-main"
                   :class="['arrow-main' , {hide: hides[index]}]">
                <i class="fa fa-chevron-right"></i>
              </div>
              <div class="name" v-if="object.name" @click="approve ? () => {} : removeObj(object, index)">
                <span
                  class="name-click"
                  v-for="(obj, index) in (object.name || '').split(' > ')"> {{ index > 0 ? ' > ' : '' }} {{
                    obj
                  }}
                </span>

                <i class="el-icon-close" v-if="!approve"></i>
              </div>
              <div class="name" v-else>
                <span>Без объекта</span>
              </div>
            </div>
          </div>
        </div>


        <div class="job-container mob-show-create" v-for="(job, i) in object.jobs" v-show="!hides[index]"
             :key="i + '_' + index  + '_' + job.id"
             v-if="job && job.job">
          <div
            style="display: flex; justify-content: space-between; align-items: center; flex: 1; width: 100%; margin-bottom: 8px; cursor: pointer">
            <span
              :class="{work_custom: job.job.work_type === 'custom'}"
              :style="{color: job.job.unit_for_value ? '#000' : 'rgba(0, 0, 0, 0.7)'}"
              style="text-align: left; font-size: 15px; margin-bottom: 4px; margin-left: 4px; cursor: pointer">
              {{ job.job.name }}, {{ job.job.unit && (job.job.unit.label || job.job.unit) }}

                    <i style="font-size: 16px; margin-top: 2px; font-weight: bold;" class="el-icon-close"
                       @click="delJob(object, index, i)"
                       v-if="!approve"></i>
            </span>
            <i :class="{'disable-report': approve}" style="font-size: 18px; margin-left: 16px;"
               class="el-icon-document-copy" @click="() => addJobs({structureObj: index, form: job})"></i>
          </div>
          <div class="job-inputs">
            <div
              @click="dotAuto(objects, index, i)"
              style="width: 28px; display: flex; flex-shrink: 0; align-items: center; justify-content: center">
              <span class="dot-auto"></span>
            </div>
            <el-input
              :class="Number(objects[index].jobs[i].value) < Number(objects[index].jobs[i].daily_plan) ? 'red' : 'green'"

              class="input"
              :key="`plan-${index}-${i}`"
              v-if="$store.state.project.daily_plan"
              type="number"
              v-model.lazy=" objects[index].jobs[i].daily_plan "></el-input>
            <el-input
              type="number"
              style="margin-bottom: 0"

              :key="`fact-${index}-${i}`" class="input" v-model.lazy="objects[index].jobs[i].value"></el-input>
            <i class="fa fa-chevron-right" @click="openJobDialog(object, job,  index, i)"></i>
          </div>
          <div class="user-row-inputs" v-if="getShowConfig(allId, 'population')">

            <i class="fas fa-user-friends"></i>

            <div class="user-row-inputs-line">
              <el-input
                type="number"
                :disabled="!isWorker"
                style="margin-bottom: 0"
                @input="changePopulation('factProf', index,i)"
                v-model="objects[index].jobs[i].job.factProf"
                placeholder="Кол-во"></el-input>
              <el-input
                type="number"

                style="margin-bottom: 0"

                v-if="isWorker" placeholder="Смена"
                @input="changePopulation('profSm', index,i)"
                v-model="objects[index].jobs[i].job.profSm"
              ></el-input>
              <el-input
                type="number"

                style="margin-bottom: 0"

                :disabled="!isWorker"
                @input="changePopulation('timeProf', index,i)"
                v-model="objects[index].jobs[i].job.timeProf"
                placeholder="Часы"></el-input>
            </div>

          </div>

          <div class="add-jobs-values" style="margin-top: 8px" v-if="getShowConfig(allId, 'plan')">
                <span style="margin-right: 8px">П: <strong>{{
                    toFixedWithoutZero(objects[index].jobs[i].job.allPlan || objects[index].jobs[i].job.plan)
                  }}</strong></span>
            <span style="margin-right: 8px">Ф: <strong>{{
                toFixedWithoutZero(objects[index].jobs[i].job.totalValue)
              }}</strong></span>
            <span style="margin-right: 8px">+\-: <strong>{{
                toFixedWithoutZero(objects[index].jobs[i].job.totalValue - (objects[index].jobs[i].job.allPlan || objects[index].jobs[i].job.plan))
              }}</strong></span>
            <strong v-if="Number(objects[index].jobs[i].job.allPlan)"
                    :style="{color: pStatus(findPercentage(objects[index].jobs[i].job.totalValue, objects[index].jobs[i].job.allPlan))}">
              {{
                findPercentage(objects[index].jobs[i].job.totalValue, objects[index].jobs[i].job.allPlan)
              }}%
            </strong>
          </div>
          <!--          <el-input-->
          <!--            v-else-->
          <!--            :key="`comment-${index}-${i}`"-->
          <!--            :class="[{'disable-report': approve}, 'comment-rep']"-->
          <!--            style="margin-top: 10px;"-->
          <!--            placeholder="Комментарий"-->
          <!--            type="textarea"-->
          <!--            :ref="`comment${index}_${i}`"-->
          <!--            v-model.lazy="objects[index].jobs[i].job.comment"-->
          <!--            @input="(e) => {-->
          <!--                        objects[index].jobs[i].job.comment = e;-->
          <!--                      }"-->
          <!--          />-->
        </div>

        <div class="desktop-show-create">
          <el-table
            border
            v-if="object.jobs && object.jobs.length"
            v-show="!hides[index]"
            :data="formatJobs(object.jobs)"
            style="width: 100%">
            <el-table-column
              min-width="200"
              prop="job.name"
              label="Наименование"
            >
              <template slot-scope="scope">
                <div style="display: flex; align-items: center">
                  <i :class="{'disable-report': approve}" style="font-size: 18px; margin-right: 8px;"
                     class="el-icon-document-copy"
                     @click="() => addJobs({structureObj: index, form:object.jobs[scope.$index]})"></i>
                  <span
                    :class="{work_custom: scope.row.job.work_type === 'custom'}"
                    style="text-align: left; font-size: 15px; margin-bottom: 4px; margin-left: 4px; cursor: pointer"
                    :style="{color: scope.row.job.unit_for_value ? '#000' : ''}"
                  >
                    <span @click="openJobDialog(object, object.jobs[scope.$index],  index, scope.$index)">{{
                        scope.row.job.name
                      }}, {{ scope.row.job.unit && (scope.row.job.unit.label || scope.row.job.unit) }}</span>
                    <i style="font-size: 16px; margin-top: 2px; font-weight: bold;" class="el-icon-close"
                       @click="delJob(object, index, scope.$index)"
                       v-if="!approve"></i>

            </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Всего" v-if="getShowConfig(object.id, 'plan')">
              <el-table-column
                prop="job.allPlan"
                v-if="getShowConfig(object.id, 'plan')"
                label="План"
                width="100">
                <template slot-scope="scope">
                  {{ toFixedWithoutZero(scope.row.job.allPlan || '') }}
                </template>
              </el-table-column>

              <el-table-column
                prop="job.allValue"
                v-if="getShowConfig(object.id, 'plan')"
                label="Факт"
                width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.job.totalValue > scope.row.job.allPlan"
                        style="color: rgb(124, 179, 66)">{{ scope.row.job.totalValue || '' }}</span>
                  <span v-else>{{ scope.row.job.totalValue || '' }}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="getShowConfig(object.id, 'fact') ? 'Суточный' : ''"
                             v-if="(getShowConfig(object.id, 'daily_plan') || getShowConfig(object.id, 'fact'))">
              <el-table-column
                prop="daily_plan"
                label="План"
                class-name="input-value"

                v-if="getShowConfig(object.id, 'daily_plan')"
                width="100">
                <template slot-scope="scope">
                  <div class="auto-input-row">
                    <span class="dot-auto"
                          @click="objects[index].jobs[scope.$index].daily_plan = parseFloat((toFloat(scope.row.job.allPlan) - toFloat(scope.row.job.totalValue)).toFixed(3)); objects[index].jobs[scope.$index].daily_plan < 0 ? objects[index].jobs[scope.$index].daily_plan = '' : ''"></span>
                    <!--                  <strong v-if="Number(scope.row.value) < Number(scope.row.daily_plan)"-->
                    <!--                          class="red">{{ toFixedWithoutZero(Number(scope.row.daily_plan) || '') }}</strong>-->
                    <!--                  <strong v-else class="green"> {{ toFixedWithoutZero(Number(scope.row.daily_plan) || '') }}</strong>-->

                    <el-input
                      :class="Number(scope.row.value) < Number(scope.row.daily_plan) ? 'red' : 'green'"

                      v-model="objects[index].jobs[scope.$index].daily_plan"/>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="value"
                class-name="input-value"

                v-if="getShowConfig(object.id, 'fact')"
                label="Факт"
                width="100">
                <template slot-scope="scope">
                  <div class="auto-input-row">
                    <span class="dot-auto"
                          @click="objects[index].jobs[scope.$index].value = (objects[index].jobs[scope.$index].daily_plan ||  parseFloat((toFloat(scope.row.job.allPlan) - toFloat(scope.row.job.totalValue)).toFixed(4))); objects[index].jobs[scope.$index].value < 0 ? objects[index].jobs[scope.$index].value ='' : ''"></span>

                    <el-input v-model="objects[index].jobs[scope.$index].value"/>
                  </div>
                </template>
              </el-table-column>
            </el-table-column>


            <el-table-column label="Норма ч/ч"
                             v-if="(getShowConfig(object.id, 'daily_norm'))">
              <el-table-column
                label="План"
                class-name="input-value"

                v-if="getShowConfig(object.id, 'daily_plan')"
                width="100">
                <template slot-scope="scope">
                  <span style="margin-left: 8px">{{ calcNormPlan(scope.row) }}</span>
                </template>
              </el-table-column>
            </el-table-column>


            <el-table-column
              width="200"
              v-if="getShowConfig(object.id, 'zone')"
              prop="job.comment"
              label="Зона работ"
            >
              <el-table-column
                width="200"
                v-if="getShowConfig(object.id, 'zone')"
              >
                <template slot-scope="scope">
                  {{ findInp('zone', scope.row) }}
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column
              :label="ob.name"
              :key="ind"
              min-width="140"
              v-for="(ob, ind) in selectInputs(object.jobs, object)">
              <el-table-column
                v-if="ob.type.value === 'population' && getShowConfig(object.id, 'plan_population')"
                prop="job.factProf"
                label="План"

                width="72">
                <template slot-scope="scope">
                  <span>{{ calcPlan(scope.row, getShowConfig(object.id, 'daily_plan')) }}</span>
                </template>
              </el-table-column>

              <el-table-column
                class-name="input-value"
                v-if="ob.type.value === 'population'"
                prop="job.factProf"
                label="Факт"
                width="64">
                <template slot-scope="scope">
                  <el-input @input="changePopulation('factProf', index, scope.$index)"
                            v-if="isWorker"
                            v-model="objects[index].jobs[scope.$index].job.factProf"/>
                  <span v-else> {{ objects[index].jobs[scope.$index].job.factProf }} </span>
                </template>
              </el-table-column>
              <el-table-column
                class-name="input-value"

                v-if="ob.type.value === 'population' && isWorker"
                prop="job.profSm"
                label="См."
                width="54">
                <template slot-scope="scope" v-if="isWorker">
                  <el-input @input="changePopulation('profSm', index, scope.$index)"
                            v-model="objects[index].jobs[scope.$index].job.profSm"/>
                </template>
              </el-table-column>

              <el-table-column
                class-name="input-value"

                v-if="ob.type.value === 'population'"
                prop="job.timeProf"
                label="Часы"
                width="63">
                <template slot-scope="scope">
                  <el-input
                    v-if="isWorker"
                    @input="changePopulation('timeProf', index, scope.$index)"
                    v-model="objects[index].jobs[scope.$index].job.timeProf"/>

                  <span v-else> {{ objects[index].jobs[scope.$index].job.timeProf }} </span>

                </template>
              </el-table-column>

              <el-table-column
                v-if="ob.type.value === 'population' &&  $store.state.project.reportOne && $store.state.project.reportOne.progressAnalytics === 'progress' "
                prop="job.factProf"
                label="Норм."

                width="72">
                <template slot-scope="scope">
                  <span v-if="calcNorm(scope.row)"
                        :class="`${calcNorm(scope.row) > scope.row.job.timeProf ? 'green' : 'red'}`">{{
                      calcNorm(scope.row)
                    }}</span>
                </template>
              </el-table-column>

              <el-table-column
                v-if="ob.type.value === 'tech'"
                prop="job.factTech"
                label="Кол."
                width="60">
              </el-table-column>

              <el-table-column
                v-if="ob.type.value === 'tech'"
                prop="job.timeTech"
                label="Часы"
                width="60">
              </el-table-column>

              <el-table-column
                v-if="ob.type.value !== 'population' && ob.type.value !== 'tech'"
                :width="(ob.type.value === 'nomenclature' || ob.type.value === 'list' || ob.type.value === 'select' || ob.type.value === 'multipleL'  || ob.type.value === 'multiple'  || ob.type.value === 'materials' || ob.type.value === 'text' || ob.type.value === 'constructions' || ob.type.value === 'constructionsL'  ||  ob.type.value ==='materialsL') ? 200 : 100">
                <template slot-scope="scope">
                  <div class="formated-text">
                    {{
                      ob.type.value !== 'date' ? findInp(ob, scope.row) : (dayjs(findInp(ob, scope.row)).isValid() ? dayjs(findInp(ob, scope.row)).format('DD-MM-YYYY') : '')
                    }}
                  </div>
                </template>
              </el-table-column>

            </el-table-column>

            <el-table-column label="Численность"
                             v-if="!getShowConfig(allId, 'population') && getShowConfig(object.id, 'plan_population')">
              <el-table-column
                prop="job.factProf"
                label="План"

                width="120">
                <template slot-scope="scope">
                  <span>{{ calcPlan(scope.row) }}</span>
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column
              width="220"
              v-if="getShowConfig(object.id, 'comment')"
              prop="job.comment"
              label="Примечание"
            >
              <template slot-scope="scope">
                <div style="display: flex; align-items: center; justify-content: center">
                  <el-input v-model="objects[index].jobs[scope.$index].job.comment"/>
                  <i v-if="scope.row.files && scope.row.files.length" style="margin-left: 8px"
                     class="el-icon-document"></i>
                </div>
              </template>

            </el-table-column>

            <el-table-column width="46"
                             v-if="!getShowConfig(object.id, 'comment')"
            >
              <template slot-scope="scope">
                <i class="el-icon-document" v-if="scope.row.files && scope.row.files.length"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!--        <div class="job-container desktop-show-create" v-for="(job, i) in object.jobs"-->
        <!--             :key="i + '_' + index  + '_' + job.id"-->
        <!--             v-if="job && job.job">-->
        <!--          <div-->
        <!--            style="display: flex; justify-content: flex-start; align-items: center; flex: 1; width: 100%; margin-bottom: 8px; cursor: pointer">-->
        <!--            <i :class="{'disable-report': approve}" style="font-size: 18px; margin-left: 16px;"-->
        <!--               class="el-icon-document-copy" @click="() => addJobs({structureObj: index, form: job})"></i>-->
        <!--            <span-->
        <!--              :class="{work_custom: job.job.work_type === 'custom'}"-->
        <!--              style="text-align: left; font-size: 15px; margin-bottom: 4px; margin-left: 4px; cursor: pointer">-->
        <!--              {{ job.job.name }}, {{ job.job.unit && (job.job.unit.label || job.job.unit) }}-->
        <!--            </span>-->
        <!--          </div>-->
        <!--          <div class="job-inputs">-->
        <!--            <el-input class="input"-->
        <!--                      :key="`plan-${index}-${i}`"-->
        <!--                      v-if="$store.state.project.daily_plan"-->
        <!--                      v-model.lazy=" objects[index].jobs[i].daily_plan "></el-input>-->
        <!--            <el-input :key="`fact-${index}-${i}`" class="input" v-model.lazy="objects[index].jobs[i].value"></el-input>-->
        <!--            <i class="fa fa-chevron-right" @click="openJobDialog(object, job,  index, i)"></i>-->
        <!--          </div>-->
        <!--          <el-input-->
        <!--            :key="`comment-${index}-${i}`"-->
        <!--            :class="[{'disable-report': approve}, 'comment-rep']"-->
        <!--            style="margin-top: 10px;"-->
        <!--            placeholder="Комментарий"-->
        <!--            type="textarea"-->
        <!--            :ref="`comment${index}_${i}`"-->
        <!--            v-model.lazy="objects[index].jobs[i].job.comment"-->
        <!--            @input="(e) => {-->
        <!--              objects[index].jobs[i].job.comment = e;-->
        <!--            }"-->
        <!--          />-->
        <!--        </div>-->


        <div class="desktop-show-create">
          <div v-show="!hides[index]" class="add-main-job" style="padding-right: 38px; box-sizing: border-box">
            <div class="plus-btn" v-if="!approve" @click="openJobDialog(object, null, index)">
              +
            </div>
          </div>
        </div>
        <div class="mob-show-create">
          <div v-show="!hides[index]" class="add-main-job"
               style="padding-right: 38px; box-sizing: border-box; justify-content: flex-end">
            <div class="plus-btn" v-if="!approve" @click="openJobDialog(object, null, index)">
              +
            </div>
          </div>
        </div>
      </div>
    </div>


    <AddObjects
      :isWorker="isWorker"
      @save="addJobs"
      :user="user"
      :dirs="dirs"
      :main-form="mainForm"
      @remove="removeReport"
      :workTypeOptions="work_type_options"
      :currentIndex="index"
      :options_works="options_works"
      :flag="true" :approve="approve" :isEditable="isEditable" ref="addObject" @add-objects="addObjects"
      :index="objects.length"/>
    <create-jobs-work
      :dirs="dirs"
      :approve="approve" v-if="objects.length" :isEditable="isEditable" @remove="removeJob"
      ref="createJobsWork"
      @save="createJobs" @copy="copyJob"/>

    <add-jobs
      :isWorker="isWorker"
      :approve="approve"
      :isEditable="isEditable"
      @save="addJobs"
      :user="user"
      @mass-add="massAdd"
      :dirs="dirs"
      :main-form="mainForm"
      @remove="removeReport"
      :workTypeOptions="work_type_options"
      :currentIndex="index"
      :options_works="options_works"
      ref="addJobs"/>
  </div>
</template>

<script>
import AddObjectJobsWork from "./AddObjectJobsWork";
import CreateJobsWork from "./CreateJobsWork";
import CreateJobsReport from "./CreateJobsReport";
import AddJobs from "./AddJobs";
import {fetchIndex} from "../../../../firestore/reports";
import {calculatePercentage, pStatus, toFixedWithoutZero, toFloat} from "../../../../utils/numberUtils";
import _, {debounce} from "lodash";
import AddObjects from "./AddObjects";
import dayjs from "dayjs";
import {getDirOptions} from "../../../../firestore/dirs";

export default {
  name: "AddJobsWork",
  components: {AddObjects, AddJobs, CreateJobsReport, CreateJobsWork, AddObjectJobsWork},
  props: ['index', 'inputObjects', 'mainForm', 'options_works', 'user', 'approve', 'isEditable', 'dirs'],
  inject: ['timeProfGlobal'],

  data() {
    return {
      search: '',
      objects: [],
      showConfig: {},
      hides: {},
      lock: false,
      options_dirs: [],
      formIndex: 0,
      hideAll: false,
      isWorker: null,
      work_type_options: [],
      allId: null,
      inputs: [],
      removeIds: [],
    }
  },
  async mounted() {
    myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('show_config')
      .get().then((data) => {
      const result = {}
      data.forEach((sub) => {
        result[sub.id] = sub.data();
        delete result[sub.id].id
        delete result[sub.id]._id

        if(result[sub.id].is_all_flag) {
          this.allId = sub.id
        }
      })


      this.showConfig = {...result}

    })
    this.formIndex = await fetchIndex(this.$store.state.project.id)
    this.objects = (this.inputObjects || []).map((d) => {
      d.jobs = d.jobs.filter((j) => j !== null)
      return d
    })


    const inputs = await myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('inputs')
      .get()

    const inpResult = []

    inputs.forEach((doc) => {
      inpResult.push({...doc.data(), id: doc.id})
    })

    this.inputs = _.orderBy(inpResult, 'index', ['asc']);


    this.getWorkType('job')

    await this.getProfJobs()
    this.options_dirs = await getDirOptions(this.$store.state.project.id);

    // this.isWorker = !!this.work_type_options.find(({label}) => label.toLowerCase() === 'рабочие')
  },
  computed: {
    isShowPlus() {
      return !this.objects.find(({name, index}) => !name && !index)
    }
  },
  watch: {
    objects: {
      handler(e) {
        this.updateObject(e)
      },
      deep: true
    }
  },
  methods: {
    updateObject: debounce(function (e) {
      this.$emit('update', e)

    }, 800),
    dotAuto(objects, index, i) {
      this.$store.state.project.daily_plan ? (objects[index].jobs[i].daily_plan ? objects[index].jobs[i].value = objects[index].jobs[i].daily_plan  : objects[index].jobs[i].daily_plan =  parseFloat((objects[index].jobs[i].job.allPlan - objects[index].jobs[i].job.totalValue).toFixed(3))):  objects[index].jobs[i].value =   parseFloat(((objects[index].jobs[i].job.allPlan || 0) - (objects[index].jobs[i].job.totalValue || 0)).toFixed(3))

      if(objects[index].jobs[i].value < 0) {
        objects[index].jobs[i].value = ''
      }
    },
    calcNormPlan(job) {
      const work_type = this.work_type_options.find(({id}) => id === job.job.work_type)

      if (work_type && work_type.data && work_type.data.unit_for_value !== undefined) {
        return parseFloat(Number((Number(work_type.data.unit_for_value || 0) * Number(toFloat(job.daily_plan)))).toFixed(1));
      }

      return 0
    },
    calcAllFact() {
      this.objects.forEach((obj, index) => {
        this.objects[index].jobs.forEach((job, indexJob) => {
          this.objects[index].jobs[indexJob].value = parseFloat((Number(this.objects[index].jobs[indexJob].daily_plan) || toFloat(job.job.allPlan) - toFloat(job.job.totalValue)).toFixed(4))

          if(this.objects[index].jobs[indexJob].value  < 0) {
            this.objects[index].jobs[indexJob].value  = ''
          }

        })
      })
    },
    calcAllPlan() {
      this.objects.forEach((obj, index) => {
        this.objects[index].jobs.forEach((job, indexJob) => {
          this.objects[index].jobs[indexJob].daily_plan = parseFloat((toFloat(job.job.allPlan) - toFloat(job.job.totalValue)).toFixed(4))

          if(this.objects[index].jobs[indexJob].daily_plan < 0) {
            this.objects[index].jobs[indexJob].daily_plan = ''
          }

        })
      })
    },
    toFloat,
    massAdd() {

    },
    findPercentage(a, b) {
      if (!a) {
        return 0
      }

      if (!b) {
        return 100
      }


      return Number((Number(a || 0) / Number(b)) * 100).toFixed(0);
    },
    changePopulation(type, indexObj, indexJob, isAdd) {
      if (isAdd) {

        const work_type = this.work_type_options.find(({value}) => value === (this.objects[indexObj].jobs[indexJob].job && this.objects[indexObj].jobs[indexJob].job.work_type))
        const work_type_dir = this.options_dirs.find(({value}) => (work_type && work_type.data && (work_type.data.dir === value)))

        if (this.objects[indexObj].jobs[indexJob].PROF.jobs === undefined && type === 'factProf') {
          this.objects[indexObj].jobs[indexJob].PROF = {
            time: (this.objects[indexObj].jobs[indexJob].job.profSm || 0) * (this.objects[indexObj].jobs[indexJob].job.factProf || 0),
            total: 0,
            value: this.objects[indexObj].jobs[indexJob].job.factProf || 0,
            jobs: [{
              ...this.isWorker,
              time: (this.objects[indexObj].jobs[indexJob].job.profSm || 0) * (this.objects[indexObj].jobs[indexJob].job.factProf || 0),
              value: this.objects[indexObj].jobs[indexJob].job.factProf || 0
            }],
            work_type_dir: work_type_dir,
            work_type: work_type
          }
        }

        this.objects[indexObj].jobs[indexJob].job.factProf = this.objects[indexObj].jobs[indexJob].job.factProf ? this.objects[indexObj].jobs[indexJob].job.factProf : ''

        return
      }



      if (this.objects[indexObj].jobs[indexJob].PROF.jobs === undefined && type !== 'profSm') {
        this.objects[indexObj].jobs[indexJob].job.profSm = this.objects[indexObj].jobs[indexJob].job.profSm || this.timeProfGlobal.value

        this.objects[indexObj].jobs[indexJob].job.timeProf = (toFloat(this.objects[indexObj].jobs[indexJob].job.profSm) || 0) * (toFloat(this.objects[indexObj].jobs[indexJob].job.factProf) || 0)

        const work_type = this.work_type_options.find(({value}) => value === (this.objects[indexObj].jobs[indexJob].job && this.objects[indexObj].jobs[indexJob].job.work_type))
        const work_type_dir = this.options_dirs.find(({value}) => (work_type && work_type.data && (work_type.data.dir === value)))

        this.objects[indexObj].jobs[indexJob].PROF = {
          time: (toFloat(this.objects[indexObj].jobs[indexJob].job.profSm) || 0) * (toFloat(this.objects[indexObj].jobs[indexJob].job.factProf) || 0),
          total: 0,
          value: this.objects[indexObj].jobs[indexJob].job.factProf || 0,
          jobs: [{
            ...this.isWorker,
            time: (toFloat(this.objects[indexObj].jobs[indexJob].job.profSm) || 0) * (toFloat(this.objects[indexObj].jobs[indexJob].job.factProf) || 0),
            value: this.objects[indexObj].jobs[indexJob].job.factProf || 0
          }],
          work_type_dir: work_type_dir,
          work_type: work_type
        }
      } else {

        if (type === 'factProf') {
          this.objects[indexObj].jobs[indexJob].job.profSm = this.objects[indexObj].jobs[indexJob].job.profSm || this.timeProfGlobal.value

          this.lock = false

          this.objects[indexObj].jobs[indexJob].job.timeProf = (toFloat(this.objects[indexObj].jobs[indexJob].job.profSm) || 0) * (toFloat(this.objects[indexObj].jobs[indexJob].job.factProf) || 0)
          this.objects[indexObj].jobs[indexJob].PROF.time = toFloat(this.objects[indexObj].jobs[indexJob].job.timeProf)
          this.objects[indexObj].jobs[indexJob].PROF.value = Number(this.objects[indexObj].jobs[indexJob].job.factProf)
          this.objects[indexObj].jobs[indexJob].PROF.jobs[0].value = Number(this.objects[indexObj].jobs[indexJob].job.factProf)
        }

        if (type === 'profSm') {

          this.objects[indexObj].jobs[indexJob].job.timeProf = (toFloat(this.objects[indexObj].jobs[indexJob].job.profSm) || 0) * (toFloat(this.objects[indexObj].jobs[indexJob].job.factProf) || 0)

          this.objects[indexObj].jobs[indexJob].PROF.time = Number(this.objects[indexObj].jobs[indexJob].job.timeProf)
          this.objects[indexObj].jobs[indexJob].PROF.jobs[0].time = Number(this.objects[indexObj].jobs[indexJob].job.timeProf)
        }

        if (type === 'timeProf') {
          this.objects[indexObj].jobs[indexJob].job.profSm = this.objects[indexObj].jobs[indexJob].job.profSm || this.timeProfGlobal.value

          if (!this.objects[indexObj].jobs[indexJob].job.factProf || this.lock) {
            this.lock = true
            this.objects[indexObj].jobs[indexJob].job.factProf = toFloat(this.objects[indexObj].jobs[indexJob].job.timeProf) / this.timeProfGlobal.value
            this.objects[indexObj].jobs[indexJob].PROF.jobs[0].value = toFloat(this.objects[indexObj].jobs[indexJob].job.timeProf) / this.timeProfGlobal.value
            this.objects[indexObj].jobs[indexJob].PROF.value = toFloat(this.objects[indexObj].jobs[indexJob].job.timeProf) / this.timeProfGlobal.value
          }

          this.objects[indexObj].jobs[indexJob].PROF.time = toFloat(this.objects[indexObj].jobs[indexJob].job.timeProf) / toFloat(this.objects[indexObj].jobs[indexJob].job.factProf)
          this.objects[indexObj].jobs[indexJob].PROF.jobs[0].time = toFloat(this.objects[indexObj].jobs[indexJob].job.timeProf) / toFloat(this.objects[indexObj].jobs[indexJob].job.factProf)
        }
      }

      this.objects[indexObj].jobs[indexJob].PROF.time = toFloat(this.objects[indexObj].jobs[indexJob].job.timeProf) / toFloat(this.objects[indexObj].jobs[indexJob].job.factProf)
      this.objects[indexObj].jobs[indexJob].PROF.jobs[0].time = toFloat(this.objects[indexObj].jobs[indexJob].job.timeProf) / toFloat(this.objects[indexObj].jobs[indexJob].job.factProf)


      this.objects[indexObj].jobs[indexJob].job.factProf = this.objects[indexObj].jobs[indexJob].job.factProf ? this.objects[indexObj].jobs[indexJob].job.factProf : ''
      this.objects = [...this.objects]
    },
    calcNorm(job) {

      const work_type = this.work_type_options.find(({id}) => id === job.job.work_type)

      if (work_type && work_type.data && work_type.data.unit_for_value !== undefined) {
        return parseFloat(Number(Number(work_type.data.unit_for_value || 0) * Number(toFloat(job.value))).toFixed(1));
      }


      return 0

    },
    calcPlan(job, flag) {
      const work_type = this.work_type_options.find(({id}) => id === job.job.work_type)

      if (work_type && work_type.data && work_type.data.unit_for_value !== undefined) {
        return parseFloat(Number((Number(work_type.data.unit_for_value || 0) * Number(flag ? toFloat(job.daily_plan || job.job.daily_plan) : toFloat(job.allPlan || job.job.allPlan))) / this.timeProfGlobal.value).toFixed(1));
      }

      return 0
    },
    getShowConfig(id, name) {
      console.log(id, name, 'id, name')
      console.log(this.showConfig, '   console.log(this.showConfig \'id, name\')')
      try {
        let config = null
        if (name === 'population' && id === this.allId) {
          const pop = this.inputs.find(({type}) => type && type.value === 'population')

          if (!pop) {
            return null
          }
          config = this.showConfig[this.allId]


          return config[pop.id];
        }

        if (!this.showConfig) {
          return false
        }


        config = this.showConfig[id];


        const values = Object.values(this.showConfig[id] || []).filter((d) => d)

        if (!this.showConfig[id] || !values.length) {

          config = this.showConfig[this.allId]
        }

        if (!config) {
          return true
        }

        return config[name];
      } catch (e) {
        return false
      }
    },
    dayjs,
    findInp(ob, inputs) {
      let input = inputs.job.inputs.find(({id}) => id === ob.id) || {}

      if (ob === 'zone') {
        input = inputs.job.inputs.find(({type}) => type === 'zone') || {}
      }
      if (input.selectValues) {
        let result = ''
        Object.values(input.selectValues).forEach((e) => {
          result = result + e.name + '\n '
          Object.values(e.values).forEach((d) => {
            result = result + d.value + '\n'
          })

        })
        return result.trim()
      }


      return input.value && input.value.label ? input.value.label : input.value
    },
    toFixedWithoutZero,
    selectInputs(jobs, object) {


      let config = {}


      if (this.showConfig[object.id]) {
        const result = Object.values(this.showConfig[object.id]).find((i) => i)

        if (result) {
          config = this.showConfig[object.id]
        } else {
          config = this.showConfig[this.allId]
        }


      } else if (this.showConfig[this.allId]) {
        config = this.showConfig[this.allId]
      } else {
        return []
      }

      return this.inputs.filter((d) => config[d.id])
    },
    formatJobs(jobs) {
      const result = []
      JSON.parse(JSON.stringify(jobs)).map((job) => {

        if (job && job.job) {
          try {
            job.job.inputs = job.job.inputs.map((input) => {
              if (input.value && input.value.label) {
                input.value = input.value.label
              } else if (Array.isArray(input.value)) {
                let result = ''
                input.value.forEach((r) => {
                  result += r.value + '\n'
                })

                input.value = result
              } else {
                input.value = input.value || ''
              }

              return input
            })
          } catch (e) {
          }

          result.push(job)
        }
      })

      return result;
    },
    hideAllHandler() {
      this.hideAll = !this.hideAll

      if (this.hideAll) {
        this.objects.forEach((j, i) => {
          this.hides[i] = true
        })
      } else {
        this.objects.forEach((j, i) => {
          this.hides[i] = false
        })
      }

      this.hides = {...this.hides}

    },
    pStatus,
    calculatePercentage,
    getRemoveIds() {
      return this.removeIds;
    },
    getTotalValueAndPlan(job) {
      let valueR = 0, planR = 0

      try {

        if (job) {
          job.reports.forEach(({jobs}) => {
            try {
              if (jobs) {
                jobs.forEach((job) => {
                  valueR += Number(job.value)
                  planR += Number(job.job.plan)
                })
              }
            } catch (e) {
            }
          })
        }
      } catch (e) {
      }

      return {value: valueR, plan: planR}
    },

    removeJob(job) {
      this.removeIds.push(job.removeId)

      const index = this.objects.findIndex(({id}) => job.structureObj === id)

      if (index !== -1) {
        this.objects[index].jobs.splice(job.editId, 1)
        this.objects = [...this.objects]
      }
    },
    hideLines(index) {
      if (!this.hides[index]) {
        this.hides[index] = true
        return this.hides = {...this.hides}
      }
      this.hides[index] = !this.hides[index]
      this.hides = {...this.hides}

    },
    calcObjectPlan(object) {
      let result = {
        plan: 0,
        value: 0
      }


      object.jobs.forEach((p) => {
        result.plan += Number(p.plan || 0)
        result.value += this.calcValue(p)
      });

      return calculatePercentage(result.value || 0, result.plan || 0) || 0
    },
    getWorkType(type) {
      console.log('GET_WORK_TYEP J')
      return new Promise((resolve) => {
        const result = [];
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('works_type')
          .where('type', '==', type).get().then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              data: data,
              value: subDoc.id,
              id: subDoc.id,
              label: (data.name || data.id || '') + (data.stamp ? ' ' + data.stamp : ''),
            });
          });
          this.work_type_options = result;
          resolve()
        });
      });
    },
    getProfJobs() {
      return new Promise((resolve) => {
        const result = [];
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('jobs')
          .where('type', '==', 'PROF').where('name', '==', 'Рабочие').get().then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            this.isWorker = data
          });
          console.log('get jobs 6')

          resolve()
        });
      });
    },
    openJobDialog(obj = {}, job = null, index, jobIndex = null) {
      this.$refs.addJobs.open(job, jobIndex, index, obj)
    },
    format(objects) {
      const result = JSON.parse(JSON.stringify(objects)).map((d) => {
        d.jobs = d.jobs.filter((j) => j !== null)
        return d
      })

      return result;
    },
    openJob(obj = {}, job = null, index = null) {
      const id = obj ? obj.id : null;
      this.$refs.createJobsWork.openHandler(id, job, index)
    },
    calcValue(job) {
      return job.value || job.fact || 0
    },
    copyJob(form) {
      const index = this.objects.findIndex(({id}) => form.structureObj === id)

      if (index !== -1) {
        this.objects[index].jobs.push({...form.form, reports: []})

      }
    },
    createJobs(form) {
      const index = this.objects.findIndex(({id}) => form.structureObj === id)

      if (form.editId === null && index !== -1) {
        this.objects[index].jobs.push(form.form)

        return this.objects = [...this.objects]
      }

      if (index === -1) {
        this.objects.push({
          id: null,
          index: null,
          name: null,
          parentId: null,
          jobs: [form.form]
        })
        return this.objects = [...this.objects]
      }


      if (index !== -1) {
        this.objects[index].jobs[form.editId] = {
          ...this.objects[index].jobs[form.editId],
          ...form.form
        }
      } else {
        this.objects[this.objects.length - 1] = {
          ...this.objects[this.objects.length - 1],
          jobs: [...this.objects[this.objects.length - 1].jobs, form.form]
        }
      }

      this.objects = [...this.objects]
    },
    removeReport(form) {
      delete this.objects[form.structureObj].jobs[form.editIndex];
      this.objects = [...this.objects].map((d) => {
        d.jobs = d.jobs.filter((j) => j !== null)
        return d
      })
    },
    addJobs(form) {
      const index = form.structureObj

      if (index !== -1 && !form.editId) {
        if (!this.objects[index].jobs) {
          this.objects[index].jobs = []
        }

        if (form.editIndex !== null && form.editIndex !== undefined) {
          this.objects[index].jobs[form.editIndex] = form.form
          this.changePopulation('factProf', index, form.editIndex, false)

        } else {
          this.objects[index].jobs.push(form.form)

          this.changePopulation('factProf', index, this.objects[index].jobs.length - 1, true)

        }

        this.objects = [...this.objects]
        return;
      }

      if (form.structureObj === null && index === -1) {
        this.objects.push({
          id: null,
          index: null,
          name: null,
          parentId: null,
          jobs: [],

        })

      } else if (index === -1) {
        return
      }

      if (index !== -1) {
        this.objects[index] = {
          ...this.objects[index],
          jobs: [...this.objects[index].jobs]
        }

        this.changePopulation('factProf', index, this.objects[index].jobs.length - 1, true)
      }
      this.objects = [...this.objects]
    },

    delJob(obj, index, i) {
      // console.log(this.objects[index].jobs[i])
      this.objects[index].jobs = this.objects[index].jobs.filter((d, dd) => dd !== i)
      this.objects = [...this.objects].filter((ob) => ob)
    },

    removeObj(obj, index) {
      this.$confirm('После удаления объекта, все работы по нему будут удалены!', 'Подтверждение', {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        delete this.objects[index]
        this.objects = [...this.objects].filter((ob) => ob)
      });
    },
    openObj() {
      this.$refs.addObject.open(null)
    },
    insertObject(arr, newObj) {
      let maxMatch = 0;
      let insertIndex = arr.length;
      let newStr = newObj.name;

      for (let i = 0; i < arr.length; i++) {
        let currentStr = arr[i].name + ' >';
        let matchLength = 0;

        while (matchLength < currentStr.length && matchLength < newStr.length && currentStr[matchLength] === newStr[matchLength]) {
          matchLength++;
        }

        if (matchLength > maxMatch) {
          maxMatch = matchLength;
          insertIndex = i + 1;
        }
      }


      arr.splice(insertIndex, 0, newObj);
      return arr;
    },
    addObjects(objs) {


      if (!objs) {
        return
      }

      this.objects.push({jobs: [], ...objs})
      this.objects = JSON.parse(JSON.stringify([...this.objects]))



      if (this.objects.length > 0 && this.objects[this.objects.length - 1].jobs.length) {
        this.objects[this.objects.length - 1].jobs.forEach((j, index) => {
          this.changePopulation('factProf', this.objects.length - 1, index, true)
        })
      }
       // setTimeout(() => {
       //   this.$emit('update', this.objects)
       // }, 500)
      // this.changePopulation('factProf', index, form.editIndex, true)


      // const objects = this.objects.filter(({id}) => id)
      // console.log(objects, objs[0], 'objs')
      //
      //
      // if(objs.mainId || !objs.name.includes(' > ')) {
      //   this.objects = _.uniqBy([...this.objects, {...objs}], 'id')
      // } else {
      //   this.objects = _.uniqBy(this.insertObject(objects, objs), 'id')
      // }
    },
    openObjectEdit(object, name) {
      this.$refs.addObject.open(object, name)
    }
  }
}
</script>

<style scoped lang="scss">
.el-icon-document {
  font-size: 22px;
}

.user-row-inputs {
  margin-top: 8px;
  display: flex;
  align-items: center;

  .user-row-inputs-line {
    display: flex;
    margin-left: 8px;

  }
}

.add-jobs-work {
  margin-top: 6px;
}

.search-jobs-work {
  display: flex;
  align-items: center;
}

.arrow-main {
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  width: 32px;
  height: 22px;
  justify-content: center;
  transform: rotate(90deg);


  &.hide {
    transform: rotate(-90deg) !important;
  }
}

@media screen and (min-width: 764px) {
  .add-jobs-work-one-report {
    margin-top: -12px;
  }
}

.icons-auto {
  display: flex;
  margin-left: 8px;

  img {
    width: 36px;
    margin-left: 4px;
    cursor: pointer;
  }
}


.add-main-job {
  margin-top: 8px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: flex-start;
  padding-left: 136px;

  span {
    font-size: 13px;
    font-weight: bold;
    margin-right: 4px;
    margin-left: 4px;
    color: #13ce66;
  }

  i {
    cursor: pointer;
    font-size: 30px;
  }
}

.precent {
  font-size: 13px;
  font-weight: bold;
  margin-right: 4px;
  margin-left: 4px;
  color: #13ce66;
}

.green {
  color: #13ce66;

  input {
    color: #13ce66 !important;

  }
}

.red {
  color: red;

}

.object-name {
  display: flex;
}

.object-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.object-name {
  display: flex;
  align-items: center;
  color: #000000;
  font-size: 14px;
  font-weight: bold;
}

.name {
  text-align: left;
}

.main-object-block {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}

.object-container {
  margin-bottom: 8px;
}

.arrow-main {
  width: 42px;
  font-size: 18px;
}

.job-inputs {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-right: 4px;

  i {
    padding-left: 4px;
    cursor: pointer;
  }
}

.input {
  margin-right: 8px;
}

.job-container {
  margin-top: 12px;
  display: flex;
  margin-bottom: 4px;
  flex-direction: column;
  align-items: flex-start;
}

.name-click {
  cursor: pointer;
}

.plus-btn {
  width: 48px;
  height: 32px;
  font-size: 22px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff8c00;
}

.fa-chevron-right {
  font-size: 20px;
}

.dot-auto {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: grey;
  display: flex;
  margin-right: 4px;
  flex-shrink: 0;
}

.work_custom {
  color: #4a36cb;
  font-weight: 500;
}

.auto-input-row {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

</style>
<style lang="scss">
.green {
  color: #13ce66;

  input {
    color: rgb(124, 179, 66) !important;
  }
}

.red {
  input {
    color: rgb(211, 47, 47) !important;
  }
}

.input-value {
  .cell {
    padding-left: 2px !important;
    padding-right: 2px !important;

    .el-input__inner {
      padding-left: 4px;
      padding-right: 4px;
    }
  }


}

.formated-text {
  white-space: pre-line !important;
  word-break: break-word !important;
}

.formated-text:first-line {
  line-height: 0 !important;
}

.comment-rep textarea {
  height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOne/components/AddJobsWork.vue